import { render } from "./SidePerimeterActions.vue?vue&type=template&id=578d35ae"
import script from "./SidePerimeterActions.vue?vue&type=script&lang=js"
export * from "./SidePerimeterActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__